import { privateApi } from 'api'
import { AxiosResponse } from 'axios'
import {
  IOrderStatisticsRequest,
  IOrderStatisticsResponse
} from 'models/orderStatistics'

export const orderStatisticsApi = {
  getOrderStatistics({
    from,
    to,
    seller_id
  }: IOrderStatisticsRequest): Promise<AxiosResponse<IOrderStatisticsResponse>> {
    const params = new URLSearchParams()

    if (from) {
      params.append('from', from)
    }

    if (to) {
      params.append('to', to)
    }

    if (seller_id) {
      params.append('seller_id', seller_id)
    }

    const query = params.toString()

    return privateApi.get<IOrderStatisticsResponse>(
      `admin/order/statistics${query ? `?${query}` : ''}`
    )
  }
}
